import { render, staticRenderFns } from "./BirthdayList.vue?vue&type=template&id=17d90af8&scoped=true"
import script from "./BirthdayList.vue?vue&type=script&lang=js"
export * from "./BirthdayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d90af8",
  null
  
)

export default component.exports